import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FieldAdministrationComponent } from './field-administration.component';

const routes: Routes = [
  {
    path: '',
    component: FieldAdministrationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FieldAdministrationRoutingModule { }
